import React from "react";
import { CardOne } from "../../../components/CardOne";

export const Location = () => {
    return (
        <div className="container py-5">
            {/* --- Título de la Sección --- */}
            <div className="text-center mb-5">
                <h2 className="display-5 fw-bold text-primary">Nuestras Ubicaciones</h2>
                <p className="text-muted">Encuentra el plantel más cercano a tu localidad</p>
                <hr className="w-25 mx-auto border-primary opacity-75" />
            </div>

            {/* --- Navegación de Pestañas (Horizontal y Centrada) --- */}
            <ul className="nav nav-pills justify-content-center mb-5 shadow-sm p-2 bg-white rounded-pill" id="locationTabs" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active rounded-pill px-4" id="itsp-tab" data-bs-toggle="pill" data-bs-target="#itsp-pane" type="button" role="tab">ITSP</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link rounded-pill px-4" id="ifm-tab" data-bs-toggle="pill" data-bs-target="#ifm-pane" type="button" role="tab">IFM</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link rounded-pill px-4" id="ipmi-tab" data-bs-toggle="pill" data-bs-target="#ipmi-pane" type="button" role="tab">IPMI</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link rounded-pill px-4" id="im-tab" data-bs-toggle="pill" data-bs-target="#im-pane" type="button" role="tab">IM</button>
                </li>
            </ul>

            {/* --- Contenido de las Pestañas --- */}
            <div className="tab-content" id="locationTabsContent">
                
                {/* SECCIÓN ITSP */}
                <div className="tab-pane fade show active" id="itsp-pane" role="tabpanel">
                    <h3 className="h4 mb-4 text-center text-secondary text-uppercase ls-2">Planteles ITSP</h3>
                    <div className="row g-4">
                        <LocationCard 
                            title="Irapuato, Gto." 
                            mapId="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4020.1881756235844!2d-101.3668852!3d20.6541501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842c7e479958d531%3A0x1352ab524d375d97!2sLa%20Resurrecci%C3%B3n%20ICIAR!5e1!3m2!1sen!2smx!4v1774285591920!5m2!1sen!2smx" 
                            address="Eucalipto 194, Los Alamos, 36568 Irapuato, Gto." 
                            link="https://goo.gl/maps/Cd1hhFAhbwPhWc429" 
                        />
                        <LocationCard 
                            title="Silao, Gto." 
                            mapId="0" 
                            address="Dirección Plantel Silao..." 
                            link="#" 
                        />
                        <LocationCard 
                            title="Moroleón, Gto." 
                            mapId="0" 
                            address="Dirección Plantel Moroleón..." 
                            link="#" 
                        />
                        <LocationCard 
                            title="Querétaro" 
                            mapId="1" 
                            address="Dirección Plantel Querétaro..." 
                            link="#" 
                        />
                    </div>
                </div>

                {/* SECCIÓN IFM */}
                <div className="tab-pane fade" id="ifm-pane" role="tabpanel">
                    <h3 className="h4 mb-4 text-center text-secondary text-uppercase ls-2">Planteles IFM</h3>
                    <div className="row g-4">
                        <LocationCard 
                            title="Irapuato - Zona 3" 
                            mapId="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4020.1881756235844!2d-101.3668852!3d20.6541501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842c7e479958d531%3A0x1352ab524d375d97!2sLa%20Resurrecci%C3%B3n%20ICIAR!5e1!3m2!1sen!2smx!4v1774285591920!5m2!1sen!2smx" 
                            address="Eucalipto 194, Los Alamos, Irapuato." 
                            link="https://goo.gl/maps/Cd1hhFAhbwPhWc429" 
                        />
                        {/* Agrega más LocationCard aquí siguiendo el mismo patrón */}
                    </div>
                </div>

                {/* SECCIÓN IPMI */}
                <div className="tab-pane fade" id="ipmi-pane" role="tabpanel">
                    <h3 className="h4 mb-4 text-center text-secondary text-uppercase ls-2">Planteles IPMI</h3>
                    <div className="row g-4">
                        <LocationCard 
                            title="Irapuato" 
                            mapId="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d254.72456445594682!2d-101.34633360951342!3d20.68081933045315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842c7fd779f683b1%3A0x10683be9da696ad5!2sTemplo%20Evangelico%20Iciar%20Emanuel!5e1!3m2!1sen!2smx!4v1774285722663!5m2!1sen!2smx" 
                            address="Isabel La Católica 519, El Ranchito, Irapuato." 
                            link="https://goo.gl/maps/jH7A3uoyr6MjBuhp6" 
                        />
                    </div>
                </div>

                {/* SECCIÓN IM */}
                <div className="tab-pane fade text-center py-5" id="im-pane" role="tabpanel">
                    <div className="p-5 bg-white rounded-4 shadow-sm">
                        <i className="bi bi-music-note-beamed display-1 text-muted opacity-25"></i>
                        <p className="mt-3 lead">Información de ubicación para el Instituto de Música disponible próximamente.</p>
                    </div>
                </div>

            </div>
        </div>
    );
};


// Sub-componente interno para evitar repetir código
const LocationCard = ({ title, mapId, address, link }) => (
    <div className="col-12 col-md-6">
        <div className="shadow-sm h-100 border-0 card rounded-4 overflow-hidden">
            <CardOne 
                name={`Instituto en ${title}`}
                location={
                    <iframe 
                        src={mapId} 
                        height="300" 
                        className="w-100"
                        style={{ border: "0" }} 
                        allowFullScreen="" 
                        loading="lazy"
                    ></iframe>
                }
                description={address}
                goLink={link}
            />
        </div>
    </div>
);